<template>
  <div v-if="MessageList.length > 0"  class="message-component mc">
    <div
      v-for="(message,index) in MessageList"
      :key="index"
      class="container alert x px-2 mc__message"
      :class="{'alert-success': !message.IsError
               , 'alert-danger': message.IsError
               , 'mc__message--sticky': message.IsSticky,
                 'mc__message--auto-height': message.AutoHeight }"
      role="alert"
      :style="`top:${(index) * 90 + 80}px;`"
    >
      <div class="row px-2">
        <div class="col">
          <a class="close" href="#" @click.prevent="CloseMessageAlert(index)">×</a>
          <div class="mt-2 px-3"><strong v-html="message.Header" /></div>
          <div class="px-3" v-html="message.Message" />
          <button 
            v-if="message.MessageLink !== undefined"
            @click="message.MessageLink.click()"
          >
            {{message.MessageLinkText}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from "vuex"

  export default {
    computed: {
      ...mapGetters(["MessageList"])
    },
    methods: {
      ...mapMutations(["removeMessage"]),
      CloseMessageAlert (index) {
        this.removeMessage(index)
      }
    }
  }
</script>

<style>

.mc__message--sticky.x{
  position:fixed;
  top: 80px;
  padding: 12px;
  width: fit-content;
  min-width:50%;
  max-width:80%;
  z-index:100;
  box-shadow: 2px 5px;
  height:auto;
  margin:0px auto;
  left:0;
  right:0;
}

.mc__message--auto-height.x.x{
  height: auto;
}

.mc__message--sticky.alert-success{
  border: 1px solid #468847;
}

.mc__message--sticky.alert-danger{
  border: 1px solid red
}

.mc{
  z-index: 100000;
  font-size: 1.2em;
}
</style>
